import React from 'react'
import classNames from 'classnames'

function ErrorBoundaryFallbackComponent(props) {
    const { title = 'Feature' } = props
    const errorClass = classNames('fs-3 flex-1 flex flex-center', {
        'pt-8': title === 'Filters'
    })
    return <div className={errorClass}>{`${title} not available`}</div>
}
// style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}

export default ErrorBoundaryFallbackComponent
